DialogAutocompleteCtrl.$inject = ['$log', '$http', '$q', '$scope'];

export default function DialogAutocompleteCtrl($log, $http, $q, $scope) {
    var dau = this;
    let modelId = $scope.model.id_model;

    dau.jsonCampoExtra = $scope.model.campoExtra;
    dau.campoExtraValor = $scope.model.campoExtraValor;
    dau.dialogHandler = $scope.dialog;
    dau.multiple = dau.jsonCampoExtra && typeof dau.jsonCampoExtra.multiple !== "undefined" && dau.jsonCampoExtra.multiple;

    dau.seleccionados = [];
    dau.options = [];
    dau.searchText = '';
    dau.loading = true;

    if ($scope.model.optionSelected != null) {
        if (dau.multiple) dau.seleccionados = $scope.model.optionSelected;
        else if (!dau.multiple) dau.seleccionados.push($scope.model.optionSelected);
    }

    function cargarOptions(text) {
        dau.loading = true;

        let params = {model_id: modelId};
        if (text.length > 0) params.search = text;

        return $http({
            method: 'GET',
            url: dau.jsonCampoExtra.url,
            headers: dau.jsonCampoExtra.headers,
            params: params
        }).success(function (data, status, headers, config) {
            dau.options = data;
            dau.loading = false;
        }).error(function (data, status, headers, config) {
            alert("Ha fallado la petición. Estado HTTP:" + status);
            dau.loading = false;
        });
    }

    cargarOptions('');

    dau.textOption = function (option) {
        return option[dau.jsonCampoExtra.text] + " " + option[dau.jsonCampoExtra.descrip];
    };

    dau.search = function () {
        cargarOptions(dau.searchText);
    };

    dau.close = function () {
        dau.dialogHandler.cancel();
    };

    dau.aceptar = function () {
        dau.dialogHandler.close(dau.seleccionados);
    };

    dau.printSeleccionados = function () {
        if (dau.seleccionados.length === 0) return "";
        let txt = [];
        dau.seleccionados.forEach((val) => txt.push(dau.textOption(val)));
        txt = txt.join(", ");
        return txt.length > 40 ? `${txt.substring(0, 40)}..(${dau.seleccionados.length} seleccionados)` : txt;
    };

    dau.seleccionar = function (option) {
        if (dau.multiple) {
            if (!dau.estaEnSeleccionados(option)) dau.seleccionados.push(option);
            else dau.seleccionados = dau.seleccionados.filter(val => val[dau.jsonCampoExtra.key] !== option[dau.jsonCampoExtra.key]);
        } else if (!dau.estaEnSeleccionados(option)) {
            dau.dialogHandler.close(option);
        }
    };

    dau.estaEnSeleccionados = function (option) {
        return typeof dau.seleccionados
            .find(val => val[dau.jsonCampoExtra.key] === option[dau.jsonCampoExtra.key]) !== "undefined";
    }
}